import React from 'react';

const SuccessMessage = ({ message, onClose }) => {
  return (
    <div style={{
      backgroundColor: '#d4edda',
      color: '#155724',
      padding: '12px 16px',
      borderRadius: '4px',
      marginBottom: '16px',
      border: '1px solid #c3e6cb',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      zIndex: 9999,
      minWidth: '300px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
    }}>
      <span>{message || 'Operation completed successfully!'}</span>
      {onClose && (
        <button
          onClick={onClose}
          style={{
            background: 'none',
            border: 'none',
            color: '#155724',
            fontSize: '16px',
            cursor: 'pointer'
          }}
        >
          ×
        </button>
      )}
    </div>
  );
};

export default SuccessMessage;
